//import images and icons
import sleep from "../assets/imgs/sleep.png";
import stay from "../assets/imgs/stay.png";
import money from "../assets/imgs/money.png";
import safar from "../assets/imgs/safar.jpg";
import religious from "../assets/imgs/religious.png";
import nature from "../assets/imgs/nature.png";
import adventure from "../assets/imgs/adventure.png";
import historical from "../assets/imgs/historical.png";
import artCultural from "../assets/imgs/art-cultural.png";
import shopping from "../assets/imgs/shopping.png";

export const TRAVEL_STYLE_QUESTIONS = [
    {
        index: 1,
        id: 1001,
        value: 0,
        label: "accommodationType",
        possibleAnswers: [
            { value: 1, groupName: "accommodation", label: "hotel" },
            { value: 2, groupName: "accommodation", label: "motel", disabled: true },
            {
                value: 3,
                groupName: "accommodation",
                label: "otherAccommodations",
                disabled: true,
            },
        ],
        active: true,
        background: stay,
    },
    {
        index: 2,
        id: 1002,
        value: 1,
        label: "priceClass",
        possibleAnswers: [
            { value: 1, groupName: "price_class", label: "economy" },
            { value: 2, groupName: "price_class", label: "midRange" },
            { value: 3, groupName: "price_class", label: "luxury" },
        ],
        active: false,
        background: money,
    },
    {
        index: 3,
        id: 1003,
        value: 2,
        label: "sleepClass",
        possibleAnswers: [
            { value: 1, groupName: "sleep_class", label: "earlyBird" },
            { value: 2, groupName: "sleep_class", label: "normal" },
            { value: 3, groupName: "sleep_class", label: "nightOwl" },
        ],
        active: false,
        background: sleep,
    },
    {
        index: 4,
        id: 1004,
        value: 3,
        label: "itineraryCompactness",
        possibleAnswers: [
            { value: 1, groupName: "energy_class", label: "low" },
            { value: 2, groupName: "energy_class", label: "midRange" },
            { value: 3, groupName: "energy_class", label: "high" },
        ],
        active: false,
        background: safar,
    },
];

export const TRAVEL_FAVORITE_QUESTIONS = [
    {
        index: 5,
        id: 1005,
        value: 0,
        name: "religious",
        label: "religious",
        background: religious,
        active: false,
    },
    {
        index: 6,
        id: 1006,
        value: 1,
        name: "nature",
        label: "nature",
        background: nature,
        active: false,
    },
    {
        index: 7,
        id: 1007,
        value: 2,
        name: "adventure",
        label: "adventure",
        background: adventure,
        active: false,
    },
    {
        index: 8,
        id: 1008,
        value: 3,
        name: "historical",
        label: "historical",
        background: historical,
        active: false,
    },
    {
        index: 9,
        id: 1009,
        value: 4,
        name: "art_cultural",
        label: "artCultural",
        background: artCultural,
        active: false,
    },
    {
        index: 10,
        id: 1010,
        value: 5,
        name: "shopping",
        label: "shopping",
        background: shopping,
        active: false,
    },
];
